import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Security } from '@shared/models/security';

@Component({
  standalone: false,
  selector: 'gstar-approval-question-modal',
  templateUrl: './approval-question-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovalQuestionModalComponent {
  counter = input.required<number>();
  security = input.required<Security>();
  isSingle = 1;
}
